import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, MenuItem } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

/** Accordion trigger styled as a menu item */
export const ThemeAccordionTrigger = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  minHeight: 48,
  padding: theme.spacing(0.75, 2),
}));

/** Container for theme options with horizontal padding */
export const ThemeOptionsContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

/** Theme option menu item with custom selected state styling */
export const ThemeOptionItem = styled(MenuItem)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  "&.Mui-selected": {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
    },
  },
  "&:hover": {
    borderRadius: theme.shape.borderRadius,
  },
}));

/** Expand icon with CSS transition for rotation */
export const ExpandIcon = styled(ExpandMoreIcon, {
  shouldForwardProp: (prop) => prop !== "isExpanded",
})<{ isExpanded: boolean }>(({ theme, isExpanded }) => ({
  transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.short,
  }),
  marginLeft: "auto",
}));
